export default __webpack_public_path__ + "static/media/whitepapereight.4fec766f.png";